import deepmerge from 'deepmerge';

import { AppConfig } from '../app-config';
import developmentConfig from './development';

const testingSixConfig = deepmerge<AppConfig>(developmentConfig, {
  baseApiPath: 'https://api-testing-six.bh-staging.com/',
  apmUrl: 'https://apm-testing-six.bh-staging.com',
  apmEnv: 'development',
  auth0: {
    domain: 'bh-testing-six.us.auth0.com',
    clientId: 'v9DO6ynfMuq63oq9vm6pYu7ye5433rz9',
    audience: 'https://api-testing-six.bh-staging.com',
  },
  keycloak: {
    enabled: true,
    authority: 'https://auth-testing.bh-staging.com/realms/testing-six',
    clientId: 'member-portal',
  },
  openReplayConfig: {
    enabled: true,
    ingestPoint: 'https://or-testing.bh-staging.com/ingest',
    projectKey: 'Z8GmkIh3ehgLhd6SAc86',
  },
  streamChatAppId: 'fyrst2dys9pk',
  streamChatDisable: false,
  stripeKey:
    'pk_test_51JjNzpFEZYlgNqDIlT9801p31tifytbne53X6CeL1uSL13APa0Fah478jyqmqK4AKUN4Lyq3P7t8JXaxBtcr9d00007nOiO1xW',
  stripePackages: {
    // C3
    PsychLed: {
      title: 'Coaching, Therapy & Medication',
      subtitle: '',
      offerText: '',
      price: '219.99',
      timeframe: 'per month',
      stripePriceId: 'price_1LG7dqFEZYlgNqDIxlHKReLW',
    },
    // C2
    CoachingAndTherapy: {
      title: 'Coaching + Therapy',
      subtitle: '',
      offerText: '',
      price: '159.99',
      timeframe: 'per month',
      stripePriceId: 'price_1JmT9HFEZYlgNqDIcE2MbPfz',
    },
    // C1
    CoachingOnly: {
      title: 'Coaching',
      subtitle: '',
      offerText: '',
      price: '79.99',
      timeframe: 'per month',
      stripePriceId: 'price_1LG7d4FEZYlgNqDIHa0nNkLi',
    },
  },
  stripePackagesOneOneTwentyThree: {
    // C3
    PsychLed: {
      title: 'Coaching, Therapy & Medication',
      subtitle: '',
      offerText: '',
      price: '549.99',
      timeframe: 'per month',
      stripePriceId: 'price_1MKvWlFEZYlgNqDIVcUPYjxd',
    },
    // C2
    CoachingAndTherapy: {
      title: 'Coaching + Therapy',
      subtitle: '',
      offerText: '',
      price: '399.99',
      timeframe: 'per month',
      stripePriceId: 'price_1MKvWHFEZYlgNqDIKuuGQHbB',
    },
    // C1
    CoachingOnly: {
      title: 'Coaching',
      subtitle: '',
      offerText: '',
      price: '199.99',
      timeframe: 'per month',
      stripePriceId: 'price_1MKvV6FEZYlgNqDIoU0GDLTf',
    },
  },
  launchDarklyKey: '66f71a6cd5eceb081d8d36bc',
  launchDarklyDisable: false,
});

export default testingSixConfig;
